
export type MarkNotificationAsFailed200BasicInfoType = typeof MarkNotificationAsFailed200BasicInfoType[keyof typeof MarkNotificationAsFailed200BasicInfoType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MarkNotificationAsFailed200BasicInfoType = {
  LIKE: 'LIKE',
  REPLY: 'REPLY',
  RETWEET: 'RETWEET',
  FOLLOW: 'FOLLOW',
  MENTION: 'MENTION',
} as const;
